export default {
    productionProcesses: [],
    productionProcessesLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        name: null,
        isVirtual: false
    }
}